module.exports = __webpack_public_path__ + "img/eg.100f1ba6.svg";